/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContactInfo
// ====================================================

export interface GetContactInfo_pdp_base_info_product_essentials {
  name: string;
  value: string;
}

export interface GetContactInfo_pdp_base_info_product {
  id: string;
  /**
   * 배송 타입
   */
  fulfillment_type: PdpCatalogFulfillmentType;
  /**
   * 원본 상품 url (등록형 상품인 경우 null)
   */
  external_product_url: string | null;
  /**
   * 입점 타입
   */
  entry_type: PdpProductEntryType;
  /**
   * 상품정보제공 고시
   */
  essentials: GetContactInfo_pdp_base_info_product_essentials[];
}

export interface GetContactInfo_pdp_base_info_shop_customer_center_business_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_customer_center_lunch_time {
  /**
   * 시작 시간
   */
  from_hm: string | null;
  /**
   * 끝 시간
   */
  to_hm: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_customer_center {
  /**
   * 고객센터 운영시간
   */
  business_time: GetContactInfo_pdp_base_info_shop_customer_center_business_time | null;
  /**
   * 고객센터 점심시간
   */
  lunch_time: GetContactInfo_pdp_base_info_shop_customer_center_lunch_time | null;
  /**
   * 고객센터 휴일
   */
  closed_week_day_list: PdpWeekDayType[] | null;
  /**
   * 공휴일 휴무 여부
   */
  is_closed_on_holiday: boolean | null;
  /**
   * 담당자명
   */
  manager_name: string | null;
  /**
   * 담당자 연락처
   */
  manager_tel: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_main_contact {
  name: string | null;
  email: string | null;
  landline_number: string | null;
  mobile_number: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_business_license {
  /**
   * 사업자등록증 번호
   */
  registration_number: string | null;
  /**
   * 업체(법인)명
   */
  company_name: string | null;
  /**
   * 대표자명
   */
  representative_name: string | null;
  /**
   * 업태
   */
  business_category: string | null;
  /**
   * 종목
   */
  business_subcategory: string | null;
  /**
   * 사업장소재지
   */
  company_address: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_shop_business_info_seller_info {
  terms_of_use_policy_url: string;
  privacy_policy_url: string;
  kakao_cs_url: string | null;
  naver_cs_url: string | null;
}

export interface GetContactInfo_pdp_base_info_shop_shop_business_info {
  seller_info: GetContactInfo_pdp_base_info_shop_shop_business_info_seller_info;
}

export interface GetContactInfo_pdp_base_info_shop_online_sales_license {
  /**
   * 라이센스 번호
   */
  license_number: string | null;
}

export interface GetContactInfo_pdp_base_info_shop {
  parent_id: string | null;
  sale_type: string | null;
  customer_center: GetContactInfo_pdp_base_info_shop_customer_center | null;
  main_contact: GetContactInfo_pdp_base_info_shop_main_contact | null;
  customer_center_tel: string | null;
  business_license: GetContactInfo_pdp_base_info_shop_business_license | null;
  shop_business_info: GetContactInfo_pdp_base_info_shop_shop_business_info | null;
  online_sales_license: GetContactInfo_pdp_base_info_shop_online_sales_license | null;
}

export interface GetContactInfo_pdp_base_info_policy_list_content_list {
  title: string;
  description: string;
}

export interface GetContactInfo_pdp_base_info_policy_list {
  main_title: string;
  content_list: GetContactInfo_pdp_base_info_policy_list_content_list[];
}

export interface GetContactInfo_pdp_base_info {
  /**
   * 입점형 내재화 상품정보
   */
  product: GetContactInfo_pdp_base_info_product;
  /**
   * 쇼핑몰 정보
   */
  shop: GetContactInfo_pdp_base_info_shop;
  /**
   * 정책 및 약관
   */
  policy_list: GetContactInfo_pdp_base_info_policy_list[];
}

export interface GetContactInfo {
  /**
   * PDP 기본 정보 (source = 네이버 등 제휴사를 통해 유입된 캠페인 코드)
   */
  pdp_base_info: GetContactInfo_pdp_base_info | null;
}

export interface GetContactInfoVariables {
  catalog_product_id: string;
  source?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PdpCatalogFulfillmentType {
  DIGITAL_DELIVERY = "DIGITAL_DELIVERY",
  MERCHANT = "MERCHANT",
  ON_SITE = "ON_SITE",
  VENDOR_FLEX = "VENDOR_FLEX",
  ZIGZIN = "ZIGZIN",
}

export enum PdpProductEntryType {
  CRAWLING_API = "CRAWLING_API",
  DIRECT = "DIRECT",
  SCRAPPING = "SCRAPPING",
}

/**
 * 휴일 요일
 */
export enum PdpWeekDayType {
  FRI = "FRI",
  MON = "MON",
  SAT = "SAT",
  SUN = "SUN",
  THU = "THU",
  TUE = "TUE",
  WED = "WED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
